import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';

import App from './components/App/App';


/* import { WordPressProvider } from 'react-wordpress-hooks';

const headers = new Headers();
headers.append(
  'Authorization',
  `Basic ${btoa('yoan:P!TpmhT%1*VQ2I(mgC')}`
); */

/* ReactDOM.render(<WordPressProvider
  config={{
    url: 'http://localhost/cmpscu-blog/wp-json/wp/v2/posts',
    headers,
  }}
>
  <App />
</WordPressProvider>, document.getElementById('root')); */

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();